module.exports = __webpack_public_path__ + "static/img/凤鸣长新.868875c8.png";